/**
 * Couleur de texte lisible (noir/blanc) selon le contraste WCAG face à une
 * couleur de fond hex. Utilisé pour le rendu des templates de branding sur
 * la page de sondage (header/boutons) — cf. task.md Story 1.
 */
export function readableTextColor(hexColor: string): "#000000" | "#ffffff" {
  const luminance = relativeLuminance(hexColor);
  const contrastWithBlack = contrastRatio(luminance, 0);
  const contrastWithWhite = contrastRatio(luminance, 1);
  return contrastWithBlack >= contrastWithWhite ? "#000000" : "#ffffff";
}

function relativeLuminance(hexColor: string): number {
  const { r, g, b } = hexToRgb(hexColor);
  const [rl, gl, bl] = [r, g, b].map((channel) => {
    const c = channel / 255;
    return c <= 0.03928 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4);
  });
  return 0.2126 * rl + 0.7152 * gl + 0.0722 * bl;
}

function contrastRatio(luminanceA: number, luminanceB: number): number {
  const lighter = Math.max(luminanceA, luminanceB);
  const darker = Math.min(luminanceA, luminanceB);
  return (lighter + 0.05) / (darker + 0.05);
}

function hexToRgb(hexColor: string): { r: number; g: number; b: number } {
  const hex = hexColor.replace("#", "");
  const normalized =
    hex.length === 3
      ? hex
          .split("")
          .map((c) => c + c)
          .join("")
      : hex;
  const value = parseInt(normalized, 16);
  return {
    r: (value >> 16) & 255,
    g: (value >> 8) & 255,
    b: value & 255,
  };
}
